import MuiTooltip from "@mui/material/Tooltip";

import { InfoOutlinedIcon } from "./icons";
import { useCallback } from "react";

export const Tooltip = (props) => {
  let { children, color, className, title, icon, onClick, ...attribute } = props || {};

  const onKeyDown = useCallback((e) => {
    if (!e || (e.key !== "Enter" && e.key !== " ")) return;
    e.preventDefault();
    if (typeof onClick == "function") {
      onClick(e);
    }
  }, [onClick]);

  className = className ? className : "ps-1";
  title = title ? title : children;
  if (!title) return null;
  const Icon = icon ? icon : InfoOutlinedIcon;

  return <MuiTooltip className={className} title={title}>
    <Icon color={color} onClick={onClick} onKeyDown={onKeyDown} tabIndex="0" aria-hidden="false" {...attribute} />
  </MuiTooltip>;
};

export default Tooltip;
